var _circle, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeetcodeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 108,
    fill: "url(#paint0_linear_1185_17060)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 91,
    fill: "url(#paint1_linear_1185_17060)",
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.817 168.315L159.823 168.309L159.83 168.302C161.803 166.325 165.137 166.352 167.269 168.485C169.401 170.617 169.43 173.951 167.451 175.93L167.447 175.934L155.286 188.225C155.285 188.226 155.285 188.227 155.284 188.227C150.917 192.593 144.861 194.898 138.112 194.898C131.341 194.898 125.292 192.762 120.942 188.421C120.941 188.421 120.941 188.421 120.941 188.42L100.674 168.088L100.673 168.087C96.3152 163.734 94 157.489 94 150.726C94 143.972 96.31 137.92 100.674 133.552L147.766 86.4547C149.751 84.4736 153.09 84.5006 155.221 86.6311C157.352 88.7629 157.381 92.1006 155.395 94.0794L155.395 94.0793L155.388 94.0859L143.885 105.757L142.621 107.039L144.378 107.434C148.503 108.362 152.284 110.429 155.291 113.4C155.292 113.401 155.293 113.402 155.295 113.404L167.452 125.687L167.456 125.691C169.434 127.669 169.406 131.004 167.273 133.141C165.141 135.272 161.808 135.3 159.83 133.318L159.823 133.312L159.817 133.305L147.248 121.16C144.832 118.744 141.537 117.787 138.046 117.787C134.578 117.787 131.208 118.653 128.774 121.087L128.769 121.092L108.636 141.51C108.635 141.511 108.634 141.511 108.633 141.512C106.24 143.906 105.07 147.178 105.07 150.722C105.07 154.25 106.231 157.71 108.634 160.114C108.635 160.114 108.635 160.115 108.636 160.115L128.832 180.456L128.834 180.459C131.255 182.879 134.552 183.838 138.046 183.838C141.537 183.838 144.832 182.881 147.248 180.465L159.817 168.315ZM133.775 145.655H181.078C183.74 145.655 186 147.968 186 150.931C186 153.895 183.74 156.207 181.078 156.207H133.775C131.109 156.207 128.854 153.895 128.854 150.931C128.854 147.967 131.109 145.655 133.775 145.655Z",
    fill: "url(#paint2_linear_1185_17060)",
    stroke: "black",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1185_17060",
    x1: 222.354,
    y1: 140,
    x2: 32,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1185_17060",
    x1: 210.916,
    y1: 140,
    x2: 47,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A981FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1185_17060",
    x1: 175.839,
    y1: 139.949,
    x2: 93,
    y2: 139.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9FE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F0FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeetcodeIcon);
export default __webpack_public_path__ + "static/media/leetcode_icon.99b2babde306a7d04ad3bc18572483d8.svg";
export { ForwardRef as ReactComponent };